export default {"src":"/_next/static/media/kominfo-text.76b6157a.svg","height":12,"width":73,"blurWidth":0,"blurHeight":0};